import React from 'react';
import type { RenderModalWrapperProps } from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { useQuickSearchAnalyticsAttributes } from '../index.tsx';

export const QuickSearchWrapper = ({ children }: RenderModalWrapperProps) => {
	const [attributes] = useQuickSearchAnalyticsAttributes();

	return (
		<JSErrorBoundary
			packageName="jiraCommandPaletteQuickSearch"
			id="quick-search"
			teamName="deliveroo"
		>
			<ContextualAnalyticsData attributes={attributes}>{children}</ContextualAnalyticsData>
		</JSErrorBoundary>
	);
};
